/**
 *
 * H4
 *
 */

import styled from 'styled-components';

const H4 = styled.h4`
  margin: 0 20px;
  font-family: poppins, sans-serif;
  font-size: 24px;
  font-weight: 300;
  height: 33px;
  line-height: 33px;
`;

export default H4;
